import { Form } from './Form'
import { Header } from './Header'

const Step1 = {
  Header,
  Form,
}

export default Step1
